import { HStack } from "@chakra-ui/react";
import { FaBox, FaBoxOpen, FaCheckCircle, FaPlayCircle } from "react-icons/fa";
import { MdAutorenew, MdDashboard } from "react-icons/md";
import { ResumoCard } from "./ResumeCard";
import { useState } from "react";


interface DashboardResumoProps {
  onClick: (label: "Todos" | "Recebimentos" | "Expedições" | "Devoluções" | "Saídas" | "Finalizadas") => void;
}

export default function DashboardResumo({ onClick }: DashboardResumoProps) {

  const [selectedLabel, setSelectedLabel] = useState<"Todos" | "Recebimentos" | "Expedições" | "Devoluções" | "Saídas" | "Finalizadas">("Todos");
  const handleCardClick = (label: "Todos" | "Recebimentos" | "Expedições" | "Devoluções" | "Saídas" | "Finalizadas") => {
    setSelectedLabel(label);
    onClick(label);
  };
  return (
    <HStack w={'100%'} px={6} pt={2} justify={'space-between'} spacing={4} wrap="wrap">
      <ResumoCard label="Todos" value={45} icon={MdDashboard} iconColor="#3182ce" onClick={handleCardClick} borderColor={selectedLabel === "Todos" ? "#3182ce" : undefined} /> 
      <ResumoCard label="Recebimentos" value={452} icon={FaBoxOpen} iconColor="#38a169" onClick={handleCardClick} borderColor={selectedLabel === "Recebimentos" ? "#3182ce" : undefined} /> 
      <ResumoCard label="Expedições" value={819} icon={FaBox} iconColor="#d69e2e" onClick={handleCardClick} borderColor={selectedLabel === "Expedições" ? "#3182ce" : undefined} />
      <ResumoCard label="Devoluções" value={20} icon={MdAutorenew} iconColor="#e53e3e" onClick={handleCardClick} borderColor={selectedLabel === "Devoluções" ? "#3182ce" : undefined} /> 
      <ResumoCard label="Saídas" value={819} icon={FaPlayCircle} iconColor="#4299e1" onClick={handleCardClick} borderColor={selectedLabel === "Saídas" ? "#3182ce" : undefined} /> 
      <ResumoCard label="Finalizadas" value={51} icon={FaCheckCircle} iconColor="#2f855a" onClick={handleCardClick} borderColor={selectedLabel === "Finalizadas" ? "#3182ce" : undefined} />
    </HStack>
  );
}
